import { useIdle } from '@mantine/hooks';
import { useEffect } from 'react';

const pool = parseInt(import.meta.env.VITE_POOLING_INTERVAL ?? '5000', 10);

export const POOLING_INTERVAL = isNaN(pool) ? 5000 : pool;

type UseIdlePooling = (args: {
  startPolling: (pollInterval: number) => void;
  stopPolling: () => void;
}) => void;

const useIdlePooling: UseIdlePooling = ({ startPolling, stopPolling }) => {
  const idle = useIdle(POOLING_INTERVAL);

  useEffect(() => {
    if (idle) {
      stopPolling();
    } else {
      startPolling(POOLING_INTERVAL);
    }
  }, [idle, startPolling, stopPolling]);
};

export default useIdlePooling;
